import { Eye } from 'lucide-react';
import { Link } from 'react-router-dom';

const BagCard = ({ bag, index = 0, toImageUrl }) => {
  const getMainImage = () => {
    if (bag?.bagImg) return bag.bagImg;
    if (Array.isArray(bag?.images) && bag.images.length > 0) {
      return bag.images[0]?.img || '';
    }
    return 'https://images.unsplash.com/photo-1553062407-98eeb64c6a62?w=600';
  };

  const imageSrc = toImageUrl ? toImageUrl(getMainImage()) : getMainImage();

  return (
    <Link
      to={`/bags/${bag._id}`}
      className="group relative block bg-white rounded-2xl overflow-hidden shadow-card hover:shadow-card-hover transition-all duration-500 transform hover:-translate-y-2"
      data-testid={`bag-card-${index}`}
      style={{ animationDelay: `${index * 100}ms` }}
    >
      <div className="relative aspect-square overflow-hidden bg-brand-muted/10">
        <img
          src={imageSrc}
          alt={bag?.bagAd || 'Çanta'}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
          loading="lazy"
          onError={(e) => {
            e.currentTarget.src = '/placeholder.png';
          }}
        />

        <div className="absolute inset-0 bg-gradient-to-t from-brand-primary/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />

        {bag?.bagCategory && (
          <span className="absolute top-4 left-4 bg-brand-primary text-white text-xs font-medium px-3 py-1.5 rounded-full">
            {bag.bagCategory}
          </span>
        )}

        <div className="absolute bottom-4 right-4 bg-white/90 backdrop-blur-sm p-2 rounded-full shadow-md opacity-0 group-hover:opacity-100 transition">
          <Eye className="w-4 h-4 text-brand-primary" />
        </div>
      </div>

      <div className="p-5">
        <h3 className="font-serif text-lg text-brand-brown group-hover:text-brand-primary transition-colors line-clamp-1">
          {bag?.bagAd || 'Adsız çanta'}
        </h3>

        {bag?.bagNov && (
          <p className="text-sm text-brand-muted mt-1 line-clamp-2">
            {bag.bagNov}
          </p>
        )}

        <p className="font-serif text-xl text-brand-primary font-semibold mt-3">
          {Number(bag?.bagPrice || 0).toFixed(2)} ₼
        </p>
      </div>
    </Link>
  );
};

export default BagCard;